import { getDomainName } from './SupportUtils';

export const addTransifexListeners = function(event) {
    const transifexApiKey = event?.transifexConfig?.webAttendeeApiKey;
    try {
        if (transifexApiKey) {
            window.Transifex.live.onReady(setTransifexSidebarPosition);
            window.Transifex.live.onTranslatePage(addLangQueryParamToIframes);
        }
    } catch (error) {
        console.error(error);
    }
};

function setTransifexSidebarPosition() {
    window.Transifex.live.sidebar?.setCookie?.('transifex_sidebar_left', 'true');
}

function addLangQueryParamToIframes(language_code) {
    window.document.querySelectorAll('iframe').forEach(function(iframe) {
        const iframeSrcSplit = iframe.src.split('?');
        const [iframeSrc = '', iframeSearchStr = ''] = iframeSrcSplit;
        const { host: iframeHost } = new URL(iframeSrc);
        const iframeDomainName = getDomainName(iframeHost);
        const currentDomainName = getDomainName(window.location.host);
        if (iframeDomainName === currentDomainName || iframeDomainName === 'bizzabo.com') {
            const iframeSearchParams = new URLSearchParams(iframeSearchStr);
            iframeSearchParams.set('lang', language_code || '');
            const newSearchStr = iframeSearchParams.toString();
            iframe.src = `${iframeSrc}?${newSearchStr}`;
        }
    });
}
